import { XMLNS } from '@shopify/polaris-viz-core';
import styles from './ChartElements.scss.js';
import { jsx } from 'react/jsx-runtime';

function ChartSVG({
  width,
  setRef,
  role = 'list',
  height,
  emptyStateText,
  emptyState = false,
  children
}) {
  return /*#__PURE__*/jsx("svg", {
    viewBox: `0 0 ${width} ${height}`,
    xmlns: XMLNS,
    width: width,
    height: height,
    className: styles.SVG,
    role: emptyState ? 'img' : role,
    "aria-label": emptyState ? emptyStateText : undefined,
    ref: setRef,
    children: children
  });
}

export { ChartSVG };
